import type { GuestLocale } from '@/lib/guestLocale'
import type { LandingCopy } from './types'
import { landingEn } from './en'
import { landingRu } from './ru'
import { landingUk } from './uk'
import { landingPl } from './pl'

const LANDING_BY_LOCALE: Record<GuestLocale, LandingCopy> = {
  en: landingEn,
  ru: landingRu,
  uk: landingUk,
  pl: landingPl,
}

export function getLandingCopy(locale: GuestLocale): LandingCopy {
  return LANDING_BY_LOCALE[locale] ?? landingEn
}

export type { LandingCopy } from './types'
export { formatLandingWord } from './types'
export { landingEn, landingRu, landingUk, landingPl }
